export const fixChangeForSliders = (change: Json, parameters: Json) => {
  const output: Json = {};
  const id = Object.keys(change)[0];
  const value = change[id];
  const param = findParameter(id, parameters);

  if (!param || param.type !== 'picker') {
    return change;
  }

  const { options = [] } = param;
  output[id] = optionsToValue(options, value);

  return output;
};

export const findParameter = (id: string, parameters: Json) => {
  for (const group of Object.values(parameters)) {
    for (const item of group.items) {
      if (item.id === id) return item;
    }
  }
};

export const optionsToValue = (options: string[], value: string) => {
  const index = options.indexOf(value) + 1;
  const len = options.length;

  const multiplier = 1 / (len * 2);
  return (index * 2 - 1) * multiplier;
};

export function camelCaseToSentenceCase(input: string) {
  return input.replace(/([a-z])([A-Z])/g, '$1 $2'); // Add space before uppercase letters
}
